<template>
  <div class="container" style="width:99%;margin-top:-25px;">
	<!--工具栏-->
	<div class="toolbar" style="float:left;padding:10px 12px;width:100%;box-sizing:border-box;background:linear-gradient(180deg,#fff 0%,#f8f9fb 100%);border-bottom:1px solid #e4e7ed;">
		<div class="filter-bar">
	<el-form :inline="true" :model="filters" :size="size" style="display:flex;align-items:center;flex-wrap:wrap;gap:6px;">
		<el-form-item style="margin-bottom:0;" class="filter-item">
			<SearchWhse ref="searchWhse" @search-whse-event="searchWhse(arguments)" perms="sys:tWaveMaster:view" type="primary"/>
		</el-form-item>
	</el-form>
	</div>
	<div class="action-bar">
		<kt-button :label="$t('action.addOrder')" perms="sys:tWaveMaster:add" type="primary" icon="el-icon-plus" @click="addOrder"/>
		<kt-button :label="$t('action.removeOrder')" perms="sys:tWaveMaster:delete" type="primary" icon="el-icon-minus" @click="removeOrder"/>
		<kt-button :label="$t('action.viewWaveDetail')" perms="sys:tWaveMaster:view" type="primary" icon="el-icon-view" @click="viewWaveDetail"/>
	</div>
	</div>
	<!--表格内容栏-->
	<kt-table permsEdit="sys:tWaveMaster:edit" permsDelete="sys:tWaveMaster:delete" permsView="sys:tWaveMaster:view" :displayOperation1Button="true" :showBatchButton1="true"
		:data="pageResult" :columns="columns" :buttonEdit="$t('action.select')" :buttonDelete="$t('action.unselect')" :batchDelete="$t('action.batchUnselect')" :batchButtonOperation1="$t('action.batchSelect')" :buttonOperation1="$t('action.showDetail')"
		@findPage="findPage" @handleEdit="handleSelect" @handleDelete="handleUnselect" @handleBatchOperation1="handleBatchSelect" @handleOperation1="handleOperation1">
	</kt-table>
	<!--新增编辑界面-->
	<el-dialog :title="operation?$t('common.add'):$t('common.edit')" width="40%" :visible.sync="editDialogVisible" :close-on-click-modal="false">
		<el-form :model="dataForm" label-width="80px" :rules="dataFormRules" ref="dataForm" :size="size">
			<el-form-item label="" prop="userId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.userId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="viewId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.viewId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="waveId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.waveId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="whId"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.whId" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="orderNumber"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.orderNumber" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="selected"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.selected" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="headerString"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.headerString" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="addWaveStatus"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.addWaveStatus" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="targetWave"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.targetWave" auto-complete="off"></el-input>
			</el-form-item>
			<el-form-item label="" prop="hide"  v-if="!dataForm.isPrimaryKey">
				<el-input v-model="dataForm.hide" auto-complete="off"></el-input>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button :size="size" @click.native="editDialogVisible = false">{{$t('action.cancel')}}</el-button>
			<el-button :size="size" type="primary" @click.native="submitForm" :loading="editLoading">{{$t('action.submit')}}</el-button>
		</div>
	</el-dialog>
  </div>
</template>

<script>
import KtTable from "@/views/Core/KtTable"
import KtButton from "@/views/Core/KtButton"
import { format } from "@/utils/datetime"
export default {
  name: 'TAfaViewWaveOrder',
	components:{
			KtTable,
			KtButton
	},
	data() {
		return {
			size: 'small',
      filters: {
        waveId: '',
        whId: ''
      },
			columns: [
        {prop:"id", label:"ID", minWidth:100},
        {prop:"selected", label:"是否选中", minWidth:100},
				{prop:"viewId", label:"查看编号", minWidth:100},
        {prop:"userId", label:"操作用户", minWidth:100},
        {prop:"whId", label:"仓库号", minWidth:100},
				{prop:"waveId", label:"波次号", minWidth:100},
				{prop:"orderNumber", label:"出库订单号", minWidth:100},
        {prop:"addWaveStatus", label:"是否加入波次", minWidth:100},
				{prop:"headerString", label:"", minWidth:100},
				{prop:"targetWave", label:"", minWidth:100},
				{prop:"hide", label:"", minWidth:100},
			],
			pageRequest: { pageNum: 1, pageSize: 8 },
			pageResult: {},

			operation: false, // true:新增, false:编辑
			editDialogVisible: false, // 新增编辑界面是否显示
			editLoading: false,
			dataFormRules: {
				label: [
					{ required: true, message: '请输入名称', trigger: 'blur' }
				]
			},
			// 新增编辑界面数据
			dataForm: {
				userId: null,
				viewId: null,
				waveId: null,
				whId: null,
				orderNumber: null,
				selected: null,
				headerString: null,
				addWaveStatus: null,
				targetWave: null,
				hide: null,
}
}
	},
	methods: {
    getParentParams: function () {
      if (this.$route.query.waveId!=null && this.$route.query.whId!=null){
        this.filters.waveId=this.$route.query.waveId
        this.filters.whId=this.$route.query.whId
        this.findPage(null)
      }
    },
    // 添加订单到波次（支持 ServiceResult 新格式和旧 ProcedureResult 格式）
    addOrder: function () {
      let whId=this.filters.whId
      let waveId=this.filters.waveId
      let userName=sessionStorage.getItem('user')
      let objReq = {whId: whId,waveId: waveId,userName: userName}
      this.$wmsApi.tAfaViewWaveOrder.addOrder(objReq).then((res) => {
        if(res.code == 200 && res.data && res.data.code === 'SUCCESS') {
          this.$message({message: this.$t("common.message.success") + (res.data.message ? ' ' + this.$t(res.data.message) : ''), type: 'success'})
        }
else if(res.code == 200 && res.data) {
          this.$message({message: this.$t("common.message.fail") + (res.data.message ? ' ' + this.$t(res.data.message) : ''), type: 'error'})
        }
else {
          this.$message({message: this.$t("common.message.fail") + '', type: 'error'})
        }
this.findPage(null)
      })
    },
    // 从波次移除订单（支持 ServiceResult 新格式和旧 ProcedureResult 格式）
    removeOrder: function () {
      let whId=this.filters.whId
      let waveId=this.filters.waveId
      let userName=sessionStorage.getItem('user')
      let objReq = {whId: whId,waveId: waveId,userName: userName}
      this.$wmsApi.tAfaViewWaveOrder.removeOrder(objReq).then((res) => {
        if(res.code == 200 && res.data && res.data.code === 'SUCCESS') {
          this.$message({message: this.$t("common.message.success") + (res.data.message ? ' ' + this.$t(res.data.message) : ''), type: 'success'})
        }
else if(res.code == 200 && res.data) {
          this.$message({message: this.$t("common.message.fail") + (res.data.message ? ' ' + this.$t(res.data.message) : ''), type: 'error'})
        }
else {
          this.$message({message: this.$t("common.message.fail") + '', type: 'error'})
        }
this.findPage(null)
      }).then(data!=null?data.callback:'')
    },
    // 显示明细界面
    viewWaveDetail: function () {
      this.$router.push({
        path: "/Wms/TAfoWaveDetail",
        query: {
          whId: this.filters.whId,
          waveId: this.filters.waveId,
          date:new Date().getTime()
        }
      })
    },
		// 获取分页数据
		findPage: function (data) {
			if(data !== null && data.pageRequest) {
				this.pageRequest.pageNum = data.pageRequest.pageNum
				this.pageRequest.pageSize = data.pageRequest.pageSize
			}
			let whId=this.filters.whId
      let waveId=this.filters.waveId
      let userName=sessionStorage.getItem('user')
      this.pageRequest.columnFilters = {whId:{name:"whId",value:whId},waveId: {name:'waveId', value:waveId},userName: {name:'userName', value:userName}}
			this.$wmsApi.tAfaViewWaveOrder.findPage(this.pageRequest).then((res) => {
				this.pageResult = res.data
			}).then(data!=null?data.callback:'')
		},
    // 选择订单
    handleSelect: function (params) {
      let objReq=[{id:params.row.id}]
      this.$wmsApi.tAfaViewWaveOrder.handleSelect(objReq).then((res) => {
        if(res.code == 200) {
          this.$message({ message: this.$t("common.message.success")+'', type: 'success' })
          this.findPage(null)
        }
else {
          this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
        }
      })
    },
    // 批量选择
    handleBatchSelect: function (data) {
		let params = [];
		for(var i=0; i<data.params.length; i++) {
			params.push({'id':data.params[i].id})
		}
this.$wmsApi.tAfaViewWaveOrder.handleSelect(params).then((res) => {
			if(res.code == 200) {
				this.findPage(null)
}
});
    },
		// 取消批量选择
    handleUnselect: function (data) {
			this.$wmsApi.tAfaViewWaveOrder.handleUnselect(data.params).then((res) => {
			if(res.code == 200) {
				this.findPage(null)
}
});
		},
    // 显示明细界面
    handleOperation1: function (params) {
      this.$router.push({
        path: "/Wms/TAfaViewWaveOrderLine",
        query: {
          userId: params.row.userId,
          viewId: params.row.viewId,
          whId: params.row.whId,
          waveId: params.row.waveId,
          orderNumber: params.row.orderNumber,
          date:new Date().getTime()
        }
      })
    },
		// 显示新增界面
		handleAdd: function () {
			this.editDialogVisible = true
			this.operation = true
			this.dataForm = {
				userId: null,
				viewId: null,
				waveId: null,
				whId: null,
				orderNumber: null,
				selected: null,
				headerString: null,
				addWaveStatus: null,
				targetWave: null,
				hide: null,
}
},
		// 编辑
		submitForm: function () {
			this.$refs.dataForm.validate((valid) => {
				if (valid) {
					this.$confirm(this.$t("common.message.confirmSubmission")+'', this.$t("common.message.prompt")+'', {confirmButtonText: this.$t("common.message.confirm")+'', cancelButtonText: this.$t("common.message.cancel")+''}).then(() => {
						this.editLoading = true
						let params = Object.assign({}, this.dataForm)
						this.$wmsApi.tAfaViewWaveOrder.save(params).then((res) => {
							if(res.code == 200) {
								this.$message({ message: this.$t("common.message.success")+'', type: 'success' })
				}
else {
								this.$message({message: this.$t("common.message.fail") + res.msg, type: 'error'})
				}
this.editLoading = false
							this.$refs['dataForm'].resetFields()
							this.editDialogVisible = false
							this.findPage(null)
						})
					})
	}
})
		},
		// 时间格式化
	dateFormat: function (row, column, cellValue, index){
    return format(row[column.property])
    }
	},
  activated: function () {
    this.getParentParams()
  },
  mounted() {
	}
}
</script>

<style scoped>
/* 工业软件风格 - 工具栏整体布局 */
.toolbar {
  font-family: "PingFang SC", "Microsoft YaHei", -apple-system, sans-serif;
}

/* 筛选条件区 - 工业软件卡片风格 */
.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  padding: 10px 14px;
  background: linear-gradient(135deg, #f8f9fb 0%, #ffffff 100%);
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  margin-bottom: 10px;
}

/* 筛选分组 */
.filter-group {
  display: flex;
  align-items: center;
  gap: 6px;
  padding-right: 10px;
  border-right: 1px solid #dcdfe6;
  margin-right: 6px;
}

/* 筛选分隔线 */
.filter-divider {
  width: 1px;
  height: 24px;
  background: linear-gradient(180deg, transparent 0%, #dcdfe6 50%, transparent 100%);
  margin: 0 4px;
}

/* 单个筛选项 */
.filter-item {
  display: flex;
  align-items: center;
  gap: 5px;
}

/* 筛选标签 */
.filter-label {
  font-size: 12px;
  color: #606266;
  font-weight: 500;
  white-space: nowrap;
  min-width: 52px;
  text-align: right;
}

/* 操作按钮区 */
.action-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-left: 6px;
}

/* 响应式 - 小屏幕 */
@media screen and (max-width: 1200px) {
  .filter-bar {
    padding: 8px 10px;
  }
  .filter-label {
    display: none;
  }
  .filter-group {
    border-right: none;
    padding-right: 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Wms/TAfaViewWaveOrder.vue